// src/components/create/createItems.ts

import type { LucideIcon } from "lucide-react";
import {
  BringToFront,
  Waypoints,
  AudioWaveform,
  HeartHandshake,
} from "lucide-react";

export interface CreateItem {
  key: string;
  label: string;
  icon: LucideIcon;
  href?: string;
  enabled: boolean;
  disabledTitle?: string;
}

export type CreateProfileType = "member" | "guest" | null;

export const getCreateItems = (
  profileType: CreateProfileType
): CreateItem[] => {
  const isMember = profileType === "member";

  return [
    {
      key: "moment",
      label: "Moment",
      icon: BringToFront,
      href: "/moments/create",
      enabled: true,
    },

    ...(isMember
      ? [
          {
            key: "pray",
            label: "Pray",
            icon: HeartHandshake,
            href: "/prayers/create",
            enabled: true,
          },
          {
            key: "journey",
            label: "Journey",
            icon: Waypoints,
            enabled: false,
            disabledTitle: "Coming soon",
          },
          {
            key: "echolit",
            label: "EchoLIT",
            icon: AudioWaveform,
            enabled: false,
            disabledTitle: "Coming soon",
          },
        ]
      : []),
  ];
};